import React from 'react'
import { Link } from "react-router-dom";

const SolarWaterHeaterSolution = () => {
  return (
    <>

      <div className="page-header dark-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="A Complete Guide to Solar Energy ..." style={{ perspective: 400 }}>
                  <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                    <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                      Solar Water Heater Solution
                    </div>
                  </div>
                </h1>
                <div className="post-single-meta wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <ol className="breadcrumb">
                    <a to='/'> <li><i className="fa-regular fa-user" /> Home</li></a>
                    <li><i className="fa-regular fa-clock" /> Solar Water Heater Solution</li>
                  </ol>
                </div>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>

      <div className="page-service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              {/* Page Single Sidebar Start */}
              <div className="page-single-sidebar">
                {/* Page Category List Start */}
                <div className="page-category-list wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <h2 className="page-category-list-title">Explore Our Services</h2>
                  <ul>
                    <li><Link to="/solar-water-heater-solution">Solar Water Heater Solution</Link></li>
                    <li><Link to="/solar-electrical-installation">Solar & Electrical Installation</Link></li>
                    <li><Link to="/on-grid-off-grid-solar">On-Grid & Off-Grid Solar</Link></li>
                    <li><Link to="/hybrid-solar-power-plant">Hybrid Solar Power Plant</Link></li>
                    <li><Link to="/EV-charging-solution">EV Charging Solution</Link></li>
                    <li><Link to="/solar-water-pump-solution">Solar Water Pump Solution</Link></li>
                  </ul>
                </div>
                {/* Page Category List End */}
                {/* Sidebar CTA Box Start */}
                <div className="sidebar-cta-box wow fadeInUp" data-wow-delay="0.25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                  <div className="sidebar-cta-header">
                    <div className="icon-box">
                      <img src="./assets/images/icon-headphone-white.svg" alt />
                    </div>
                    <div className="sidebar-cta-image">
                      <figure>
                        <img src="./assets/images/sidebar-cta-image.png" alt />
                      </figure>
                    </div>
                  </div>
                  <div className="sidebar-cta-body">
                    <h2>Contact Us For a Quote</h2>
                    <ul>
                      <li>Call Us: <a href="tel:+91 9516839231">+91 9516839231</a></li>
                    </ul>
                  </div>
                </div>
                {/* Sidebar CTA Box End */}
              </div>
              {/* Page Single Sidebar End */}
            </div>
            <div className="col-lg-8">
              {/* Service Single Content Start */}
              <div className="service-single-content">
                {/* Page Single Image Start */}
                <div className="page-single-image">
                  <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                    <img src="./assets/solar/Services-Solar-Water-Heater.webp" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                  </figure>
                </div>
                {/* Page Single Image End */}
                {/* Service Entry Start */}
                <div className="service-entry">
                  <div className="service-offer-box">
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Efficient Hot Water with Clean Solar Energy
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>At Solar World Enterprises, we provide reliable Solar Water Heater Solutions designed to help homes, businesses, hotels, hospitals, hostels, institutions, and other facilities meet their hot-water requirements using the power of the sun.</p>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Solar water heaters use solar energy to heat water, helping reduce reliance on conventional electricity or other fuel sources used for water heating. Our team helps customers select a suitable system based on hot-water consumption, available installation space, property type, and specific requirements.</p>
                    {/* Service Offer Box List Start */}
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block', marginTop: "20px" }}>
                          Our Solar Water Heater Services
                        </div>
                      </div>
                    </h2>
                    <div className="service-offer-box-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                      <ul>
                        <li><b>System Consultation:</b> We understand your hot-water requirements and recommend a suitable solution.</li>
                        <li><b>Site Assessment:</b> We evaluate available rooftop or installation space, sunlight exposure, and other site conditions.</li>
                        <li><b>System Installation:</b> Professional installation of the solar water heating system and associated components.</li>
                        <li><b>System Testing:</b> We check the installation and system operation before commissioning.</li>
                        <li> <b>Maintenance & Support:</b> Assistance with routine maintenance, inspection, and troubleshooting.</li>
                      </ul>
                    </div>
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block', marginTop: "20px" }}>
                          Key Benefits
                        </div>
                      </div>
                    </h2>
                    <div className="service-offer-box-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                      <ul>
                        <li><b>☀️ Uses Renewable Solar Energy</b> Harnesses sunlight as a natural source of heat.</li>
                        <li> <b> 💰 Helps Reduce Energy Expenses:</b> Can reduce the need for conventional water-heating energy. </li>
                        <li> <b> 🌱 Environment-Friendly Solution:</b>  Supports greater use of clean and renewable energy.</li>
                        <li> <b> 🏠 Suitable for Multiple Applications:</b>  Ideal for residential, commercial, institutional, and hospitality requirements.</li>
                        <li> <b> 🔧 Long-Term Solution:</b>  Designed to provide dependable hot-water generation with appropriate maintenance.</li>
                        <li> <b> ⚡ Reduced Conventional Energy Dependence:</b> Helps customers make greater use of solar energy for everyday hot-water needs. </li>
                      </ul>
                    </div>
                  </div>
                  {/* Service Offer Box End */}
                  {/* Service Key Benefits Start */}
                  <div className="service-key-benefits">
                    {/* Service Key Benefits Body Start */}
                    <div className="service-key-benefits-body">
                      {/* Service Benefits Image Start */}
                      <div className="service-benefit-image">
                        <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                          <img src="./assets/images/service-benefit-image.jpg" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                        </figure>
                      </div>
                      {/* Service Benefits Image End */}
                      {/* Service Benefits Item List Start */}
                      <div className="service-benefit-item-list">
                        {/* Service Benefits Item Start */}
                        <div className="service-benefit-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                          <div className="icon-box">
                            <img src="./assets/images/icon-service-benefit-1.svg" alt />
                          </div>
                          <div className="service-benefit-item-content">
                            <h3>Our Working Process</h3>
                            <p><b>Requirement Assessment → Site Survey → System Selection → Installation → Testing → Commissioning → After-Sales Support</b></p>
                            <h3>Harness the Sun for Hot Water</h3>
                            <p>With Solar World Enterprises, you can take advantage of solar energy for your daily hot-water requirements while supporting a cleaner and more sustainable approach to energy use.</p>
                          </div>

                        </div>
                      </div>
                      {/* Service Benefits Item List End */}
                    </div>

                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block', marginTop: "20px" }}>
                          Why Choose Our Installation Services?
                        </div>
                      </div>
                    </h2>
                    <div className="service-offer-box-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                      <ul>
                        <li><b>Professional Installation:</b> Careful and systematic installation by trained personnel.</li>
                        <li><b>Customized Solutions:</b> Installation planned according to your property's energy requirements and available space.</li>
                        <li><b>Safety Focused:</b> Attention to electrical connections, protection, earthing, and overall system safety.</li>
                        <li><b>Quality Components:</b> Suitable solar and electrical components selected according to project requirements.</li>
                        <li> <b>Efficient Execution:</b> A structured installation process designed to minimize disruption.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default SolarWaterHeaterSolution